import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import Text from 'components/shared/Text';
import Spinner from 'components/shared/Spinner';
import styles from './styles.module.scss';

function usePrevious(value, pair) {
  const prevValue = useRef();
  const prevPair = useRef();

  useEffect(() => {
    prevValue.current = value;
    prevPair.current = pair;
  }, [value, pair]);

  return { prevValue: prevValue.current, prevPair: prevPair.current };
}

function getIsUpColor(isUp) {
  let initialColor = '';
  if (isUp !== undefined) {
    initialColor = isUp ? 'var(--color-green)' : 'var(--color-red)';
  }
  return initialColor;
}

function MarketTicker(props) {
  const [color, setColor] = useState(getIsUpColor(props.isUp));
  const { prevValue, prevPair } = usePrevious(parseFloat(props.value), props.pair);

  useEffect(() => {
    if (props.isUp !== undefined) {
      setColor(getIsUpColor(props.isUp));
    } else if (prevPair && prevPair !== props.pair) {
      setColor(getIsUpColor(props.isUp));
    } else if (prevValue && prevValue !== parseFloat(props.value)) {
      const newColor = parseFloat(props.value) > prevValue ? 'var(--color-green)' : 'var(--color-red)';
      setColor(newColor);
    }
  }, [prevValue, prevPair, props.value, props.pair, props.isUp]);

  return (
    <div className={styles.marketTicker}>
      <div className={styles.valueContainer}>
        {props.loading ? (
          <div className={styles.loadingContainer}>
            {props.loadingPlaceholder && (
              <Text styles={[styles.loadingPlaceholder, styles.value]}>
                {props.loadingPlaceholder} {props.valueSuffix}
              </Text>
            )}
            <div className={styles.spinnerContainer}>
              <Spinner size="small" />
            </div>
          </div>
        ) : (
          <Text style={{ color: props.noColor ? 'var(--text)' : color }} styles={[styles.value]}>
            {props.displayValue || props.value} {props.valueSuffix}
          </Text>
        )}

        {props.subtitle && <Text muted>{props.subtitle}</Text>}
      </div>

      <Text styles={[styles.label]} muted>
        {props.label}
      </Text>
    </div>
  );
}

MarketTicker.propTypes = {
  pair: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string.isRequired, PropTypes.number]),
  loading: PropTypes.bool,
  loadingPlaceholder: PropTypes.string,
  displayValue: PropTypes.string,
  valueSuffix: PropTypes.string,
  subtitle: PropTypes.string,
  isUp: PropTypes.bool,
  noColor: PropTypes.bool
};

MarketTicker.defaultProps = {
  loading: false,
  loadingPlaceholder: undefined,
  value: null,
  valueSuffix: '',
  displayValue: undefined,
  subtitle: undefined,
  isUp: undefined,
  noColor: false
};

export default MarketTicker;
